'use client';

import { useEffect } from 'react';

import posthog from 'posthog-js';

import { IS_PRODUCTION } from '@/common/constants';
import { Button } from '@/components/ui/button';
import { useDevErrorReset } from '@/hooks/use-dev-error-reset';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (IS_PRODUCTION) {
      posthog?.captureException(error);
    }
  }, [error]);

  useDevErrorReset(error, reset);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-4 text-center">
        <h1 className="text-2xl">Oops! Something went wrong</h1>
        <p className="text-muted-foreground">Please try again or refresh the page.</p>
        <Button onClick={() => reset()}>Try again</Button>
      </div>
    </div>
  );
}
